// extracted by mini-css-extract-plugin
module.exports = {"verticalMenu":"style_verticalMenu__1MKHG"};